import { render, staticRenderFns } from "./toggleRole.vue?vue&type=template&id=b1854afe&scoped=true"
import script from "./toggleRole.vue?vue&type=script&lang=js"
export * from "./toggleRole.vue?vue&type=script&lang=js"
import style0 from "./toggleRole.vue?vue&type=style&index=0&id=b1854afe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1854afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1854afe')) {
      api.createRecord('b1854afe', component.options)
    } else {
      api.reload('b1854afe', component.options)
    }
    module.hot.accept("./toggleRole.vue?vue&type=template&id=b1854afe&scoped=true", function () {
      api.rerender('b1854afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/loginModal/toggleRole.vue"
export default component.exports